import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ControleQuinquennalApi } from "../controle-quinquennal.api";
import { controleQuinquennalKeys } from "./controle-quinquennal.keys";

export const useRelaunchAxeMutation = (idEntreprise: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      idControleQuinquennal,
      idAxe,
    }: {
      idControleQuinquennal: string;
      idAxe: string;
    }) =>
      ControleQuinquennalApi.relaunchAxeAnalysis(idControleQuinquennal, idAxe),
    onSuccess: (_data, { idControleQuinquennal, idAxe }) => {
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.detail(idEntreprise),
      });
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.axesWithFilesBase(
          idControleQuinquennal,
          idAxe
        ),
      });
      void queryClient.invalidateQueries({
        queryKey: controleQuinquennalKeys.axeVerifications(
          idControleQuinquennal,
          idAxe
        ),
      });
    },
  });
};
